import React, { useEffect, useState, useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { AuthContextProvider } from 'context/AuthContextProvider';
import { LoaderContext } from 'context/LoaderContextProvider';
import { SizeContext } from 'context/SizeContextProvider';

import ChatSession from './chatSession/ChatSession';
import { SdmTypography, SdmCountdownRedirect } from 'components';
import { useChatAuth } from 'utils/useChatAuth';
import { useIntl } from 'react-intl';
import { useDataHelper } from '../utils/dataHelper';
import translations from 'utils/translations';
import { usePubnabLambdaServices } from 'utils/pubnubLambdaHelper';
import { breakoutRoomInviteModel } from 'entities/breakoutRoomInviteModel';

import { theme } from 'theme';
const ChatSessionRouter = ({
  onLoggedUser: setUser,
  onDetectedEmail: setDetectedEmail,
  locale,
  loggedUser,
}) => {
  //Hooks
  const chatAuthService = useChatAuth();
  const intl = useIntl();
  const i18nChannelRoutingErrors =
    translations.chatPage(intl).channelRoutingErrors;
  const dataHelper = useDataHelper();

  //States
  const [session, setSession] = useState();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isModerator, setIsModerator] = useState(false);
  const [isVip, setIsVip] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  //Contexts
  const { setLoaderActive } = useContext(LoaderContext);
  const { getInnerHeight } = useContext(SizeContext);
  //Loader Function
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);

  useEffect(() => {
    if (!session) getSessionFromParams();
    else if (loggedUser) checkAuthorization();
  }, [session, loggedUser]);

  const getSessionFromParams = () => {
    const params = new URLSearchParams(location.search);
    const _session = params.get('session');
    setSession(_session);
  };

  const checkAuthorization = async () => {
    showLoader();
    const input = {
      sessionId: session,
      accessToken: loggedUser.id,
    };
    //TODO: modificare la lambda per relevare anche invitationType
    const invitationInfoResponse = await chatAuthService.getInvitationInfo(
      input
    );

    if (!invitationInfoResponse.isInvited) {
      // if not invited, it is or a speaker or a user or the moderator
      const pubnubLambdaHelper = usePubnabLambdaServices(input);

      const _isModerator = await pubnubLambdaHelper.isModerator();

      setIsModerator(_isModerator);
    } else {
      setIsVip(
        invitationInfoResponse.invitationType ===
          breakoutRoomInviteModel.enums.invitationTypes.VIP
      );
    }
    //let try to open chat session to everybody
    setIsAuthorized(true);
    hideLoader();
    setIsLoading(false);
  };

  const renderError = (message) => {
    return (
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: ' column',
          height: `${getInnerHeight()}px`,
        }}
      >
        <SdmTypography
          variant={'h1'}
          textAlign={'center'}
          style={{ color: theme.colors.primary.red }}
        >
          {message}
        </SdmTypography>
        <SdmCountdownRedirect
          variant={'h4'}
          textAlign={'center'}
          style={{ color: theme.colors.primary.red }}
          callback={handleBack}
          isActive={true}
        />
      </div>
    );
  };

  const handleBack = () => {
    dataHelper.backToBr(loggedUser?.externalId);
  };

  return (
    <AuthContextProvider
      onLoggedUser={setUser}
      onDetectedEmail={setDetectedEmail}
    >
      {/* <div style={{ width: '80%', margin: '0 auto', maxWidth: 1250 }}> */}
      {!loggedUser ? (
        <></>
      ) : (
        <Switch>
          <Route exact path="/">
            {session && isAuthorized ? (
              <ChatSession
                locale={locale}
                loggedUser={loggedUser}
                session={session}
                isModerator={isModerator}
                isVip={isVip}
              />
            ) : isLoading ? null : (
              renderError(
                !session
                  ? i18nChannelRoutingErrors.channelNotFound
                  : !isAuthorized
                  ? i18nChannelRoutingErrors.notInvited
                  : i18nChannelRoutingErrors.genericError
              )
            )}
          </Route>
        </Switch>
      )}
    </AuthContextProvider>
  );
};

export default ChatSessionRouter;
